import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';
import { ADMISION } from './Styles/StylesAdmision';

import logo from "../../assets/img/logo_menu_black.png";
import { formatReconver } from "../../funciones/GeneralFunctions";

class IngresosRpt extends Component {
    state = {  }

    contenido = () => {
        const styles = StyleSheet.create(ADMISION[0]);
        let { tipo, cantidad, ingresos, transacciones, mes, fecha, fecha2, seccion, busqueda, hist } = this.props;
        let Meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]

        let cant = cantidad;
        if (cantidad === "all") cant = "TODOS LOS"
        let formatNumber = (num) => {
            if (!num || num == 'NaN') return '-';
            if (num == 'Infinity') return '&#x221e;';
            num = num.toString().replace(/\$|\,/g, '');
            if (isNaN(num))
                num = "0";
            let sign = (num == (num = Math.abs(num)));
            num = Math.floor(num * 100 + 0.50000000001);
            let cents = num % 100;
            num = Math.floor(num / 100).toString();
            if (cents < 10)
                cents = "0" + cents;
            for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3) ; i++)
                num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
            return (((sign) ? '' : '-') + num + ',' + cents);
        }

        let nombre = (nombre) => {
            if (nombre === null) return "";
            return nombre;
        }

        let fechaFormat = (fecha) => {
            let diaActual = new Date(fecha);

            let day = diaActual.getDate();
            let month = diaActual.getMonth() + 1;
            let year = diaActual.getFullYear();
            
            return  day + '/' + month + '/' + year;
        }

        let tipoIng =() => {

            switch (tipo) {
                case "Ingresos del Dia": return tipo.toUpperCase()
                case "Ingresos del Mes": 
                if (mes === "") return `NINGÚN MES SELECCIONADO`
                return `${tipo.toUpperCase()} DE ${Meses[parseInt(mes) - 1]}`
                case "Ingresos por Rango de Fechas": return `INGRESOS DESDE ${fechaFormat(fecha)} HASTA ${fechaFormat(fecha2)}`
                case "Ingresos por Sección": return `INGRESOS DE ${seccion}`
                case "Ingresos por Estudiante": return `INGRESOS DE LA BÚSQUEDA (${busqueda.toUpperCase()})`
            }
        }

        let asientos = () => {
            if (transacciones.length === 0) return (
                <View style={[styles.row]}>
                    <Text style={[styles.colTabla10, styles.font9, styles.bordeCol11, {textAlign: "center"}]}>No existen ingresos</Text>
                </View>
            )
            
            return (
                transacciones.map(option => (
                    <View key={option.id} style={[styles.row]}>
                        <Text style={[styles.colTablaInsc5, styles.font8, styles.bordeCol11, styles.borderTop, styles.center]}>{option.id}</Text>
                        <Text style={[styles.colTablaIngr1, styles.font8, styles.bordeCol9, styles.borderTop]}>{`${option.nacionalidad}${option.ci} - ${option.nombre_1} ${nombre(option.nombre_2)} ${option.apellido_1} ${nombre(option.apellido_2)}`}</Text>
                        <Text style={[styles.colTablaIngr2, styles.font8, styles.bordeCol9, styles.borderTop, styles.center]}>{option.fecha}</Text>
                        <Text style={[styles.colTablaIngr3, styles.font7, styles.bordeCol9, styles.borderTop]}>{option.item}</Text>
                        <Text style={[styles.colTablaIngr2, styles.font8, styles.bordeCol9, styles.borderTop, styles.center]}>{parseFloat(option.haber).toFixed(2)} Bs.</Text>
                    </View>
                ))
            )
        }

        let estHist = () => {
            if (hist === false) return null;
            return (
                <View style={[styles.row]}>
                    <Text style={[styles.col3, styles.font8, {color: "#c60000"}]}>ESTADO DE CUENTA HISTÓRICO</Text>
                </View>
            )
        }
        return (
            <React.Fragment>
                <View style={styles.row}>
                    <Image
                        style={[styles.colContent40, styles.logo]}
                        src={logo}
                    />
                    <View style={[styles.colContent60, styles.header1Left,{marginTop: 14,}]}>
                        <Text style={[styles.Negrita]}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                        <Text style={[styles.textPeq]}>REGISTRO M.E, Nº 130 G.O. Nº 36.719  9 JUNIO 1.999 | RIF.J-30583313-3</Text>
                    </View>
                </View>
                <Text style={[styles.titulo, styles.header1Right, styles.custonMt10, styles.customMl,
                    {fontSize: 14, backgroundColor: "#777", color:"#FFF", padding: 2, borderRadius: 2}]}>
                    CONTROL DE {tipo.toUpperCase()}
                </Text>
                <View style={[styles.bordeConstancia, {backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>I. DETALLES DE LAS TRANSACCIONES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.col3, styles.font8]}>MOSTRANDO {cant} REGISTROS</Text>
                            {/* <Text style={[styles.col3, styles.font8, {textAlign: "right", color: "#c60000"}]}>TOTAL DE  {`${tipoIng()}: ${formatNumber(ingresos)} Bs. - ${formatReconver(ingresos)} Bs.`}</Text> */}
                            <Text style={[styles.col3, styles.font8, {textAlign: "right", color: "#c60000"}]}>TOTAL DE {`${tipoIng()}: ${formatNumber(ingresos)} Bs.`}</Text>
                        </View>
                        {estHist()}
                    </View>
                </View>
                <View style={[styles.bordeConstancia, {marginTop: 5, backgroundColor: "#FFF", padding: 4,}]}>
                    <Text style={[styles.font10, {backgroundColor: "#ccc"}]}>II. LISTADO DE TRANSACIONES</Text>
                    <View style={[{paddingLeft: 5, paddingTop: 5, backgroundColor: "#fff"}]}>
                        <View style={[styles.row]}>
                            <Text style={[styles.colTablaInsc5, styles.font9, styles.bordeCol11, styles.borderTop, {textAlign: "center", backgroundColor: "#777", color:"#FFF"}]}>N°</Text>
                            <Text style={[styles.colTablaIngr1, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>ESTUDIANTE</Text>
                            <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>FECHA</Text>
                            <Text style={[styles.colTablaIngr3, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>DESCRIPCION</Text>
                            <Text style={[styles.colTablaIngr2, styles.font9, styles.bordeCol9, styles.borderTop, styles.center, {backgroundColor: "#777", color:"#FFF"}]}>MONTO</Text>
                        </View>
                        {asientos()}
                    </View>
                </View>
                <View style={[styles.footer]}>
                    <View style={[styles.row]}>
                        <View style={[styles.col6]}>
                        <Text style={[styles.linea3]}></Text>
                            <Text style={[styles.encabezado2]}>
                                Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                C.P.1061  Edo Miranda - Caracas - Venezuela
                            </Text>
                            <Text style={[styles.encabezado2, {marginTop: -5}]}>
                                Telefax: +58 212 9930983 | 9939139 | 9910710.
                            </Text>
                        </View>
                    </View>
                </View>
            </React.Fragment>
        )
    }
    
    render() { 
        const styles = StyleSheet.create(ADMISION[0]);
        return (
            <PDFViewer style={styles.section}>
                <Document title="Listado de Estudiantes Inscritos">
                    <Page size="letter" style={styles.body}>
                        <View>
                            {this.contenido()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}
 
export default IngresosRpt;


// WEBPACK FOOTER //
// ./src/components/Reportes/IngresosRpt.jsx